import { axiosInstance as request } from '@api/rest.service'
import { getFilters } from '@/modular-api/utils'

/**
 * @description GET /publishers/{id}/subscriptions
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER_SUBSCRIPTIONS = id => request.get(`/publishers/${id}/subscriptions`)

/**
 * @description GET /publishers
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHERS = () => request.get('/publishers')

/**
 * @description GET /publishers?paginated=true (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_PUBLISHERS = params => request.get('/publishers?paginated=true', { params })

/**
 * @description GET /publishers/create
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER_CREATE = () => request.get('/publishers/create')

/**
 * @description POST /publishers
 * @returns {AxiosPromise<any>}
 */
export const CREATE_PUBLISHER = payload => request.post('/publishers', payload)

/**
 * @description GET /publishers/{id}?include=addresses
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER = id => request.get(`/publishers/${id}?include=addresses`)

/**
 * @description PATCH /publishers/{id}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_PUBLISHER = (id, payload) => request.patch(`/publishers/${id}`, payload)

/**
 * @description GET /publishers/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER_DELETE_CONFIRMATION = id => request.get(`/publishers/${id}/delete-confirmation`)

/**
 * @description DELETE /publishers/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_PUBLISHER = id => request.delete(`/publishers/${id}`)

/**
 * @description GET /publishers/{id}/products?paginated=true
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER_PRODUCTS = (id, params, filters) => {
  const paramsWithFilters = {
    ...getFilters(filters),
    ...params
  }

  return request.get(`/publishers/${id}/products?paginated=true`, { params: paramsWithFilters })
}

/**
 * @description GET /publishers/{id}/contacts
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER_CONTACTS = id => request.get(`/publishers/${id}/contacts`)

/**
 * @description GET /publishers/{id}/licenses?include=periods.owner
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER_LICENSES = id => request.get(`/publishers/${id}/licenses?include=periods.owner`)

/**
 * @description GET /publishers/{id}/orders
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER_ORDERS = id => request.get(`/publishers/${id}/orders`)

/**
 * @description GET /publishers/{id}/invoices
 * @returns {AxiosPromise<any>}
 */
export const GET_PUBLISHER_INVOICES = id => request.get(`/publishers/${id}/invoices`)
